import React from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { auth } from './firebase';
import { sendEmailVerification, signInWithEmailAndPassword } from 'firebase/auth';
import { toast } from 'react-toastify';
import './LoginForm.css';

function EmailVerification() {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, password } = location.state || {};

  if (!email || !password) {
    // If there's no email/password in state, we can't do anything.
    // Redirect to login.
    setTimeout(() => navigate('/login'), 0);
    return null;
  }

  const handleResend = async () => {
    try {
      // To resend, we need to quickly log in, send, and log out.
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      if (userCredential.user && !userCredential.user.emailVerified) {
        await sendEmailVerification(userCredential.user);
        toast.success('Link aktywacyjny został wysłany ponownie.');
      }
      await auth.signOut(); // Log out immediately
    } catch (error) {
      toast.error('Wystąpił błąd podczas ponownego wysyłania linku.');
      console.error('Błąd przy ponownym wysyłaniu e-maila weryfikacyjnego:', error);
      // Ensure user is logged out in case of error
      if (auth.currentUser) {
        await auth.signOut();
      }
    }
  };

  return (
    <div className="wrapper">
      <div className="form-box">
        <h1>Weryfikacja adresu e-mail</h1>
        <p>
          Link aktywacyjny został wysłany na Twój adres e-mail: <strong>{email}</strong>.
        </p>
        <p><br/>
          Prosimy, kliknij w link, aby aktywować swoje konto, a następnie wróć na stronę logowania.
        </p>
        
        <button type="button" onClick={handleResend} style={{ marginTop: '20px' }}>
          Wyślij link ponownie
        </button>

        <div className="register-link" style={{ marginTop: '20px' }}>
          <p>
            <Link to="/login">Wróć do logowania</Link>
          </p>
        </div>

        <div className="resend-tips" style={{ marginTop: '20px' }}>
          <p className="tips-header">Wskazówki:</p>
          <ul>
            <li>Sprawdź folder spam.</li>
            <li>Link aktywacyjny jest ważny 24 godziny.</li>
            <li>Upewnij się, że podałeś poprawny adres.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default EmailVerification;
